import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import { GlobalState } from "context/GlobalContext";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";
import FileSaver from "file-saver";
import { filterColArry } from "./data";
import { getColDefaultValue, isColumnDefault } from "components/EboStoreV4/data";
import { DownloadRounded } from "@mui/icons-material";
import { constraintsOptions, inputTypes, selectOptKeyName } from "data/globalData";
import RenderInputField from "components/EboStoreV4/CommonComponents/RenderInputFiled/RenderInputFiled";

const InventorySnapshot = () => {
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const [loading, setLoading] = useState(false);
	const [sync, setSync] = useState();
	const [filterColumns, setFilterColumns] = useState(filterColArry);

	const defaultData = filterColArry?.reduce((acc, row) => {
		acc[row.key] = getColDefaultValue(row);
		return acc;
	}, {});

	const [filterData, setFilterData] = useState({ ...defaultData });

	const fetchSync = async () => {
		try {
			await axios.get(`/api/custom_queries/fetch_last_sync`).then((res) => {
				if (res.status === 200) {
					setSync(res?.data[0]?.api_pull_last_updated);
					setLoading(false);
				}
			});
		} catch (error) {
			setLoading(false);
		}
	};

	const fetchDropdownValues = async () => {
		setLoadingOpen(true);
		const body = {
			tables: [
    { table: "adroit-standard-379209.RTPLREP.ITEM_MASTER", columns: [ "BRAND", "DEPARTMENT", "SEASON", "DIVISION", "SUB_BRAND"] },
    { table: "adroit-standard-379209.UC_API_RAREBOX.inventory_snapshot", columns: ["Facility"] }
  ]
		};
		try {
			await axios.post("/api/custom_queries/get_dropdown_value", body).then((res) => {
				setFilterColumns((allColumns) => {
					const dropdownData = res.data;
					return allColumns.map((row) => {
						if (
							dropdownData[row.key] &&
							[inputTypes.SELECT.key, inputTypes.MULTIPLE_SELECT.key].includes(row?.input_type)
						) {
							let opt = row[selectOptKeyName] ? row[selectOptKeyName] : {};
							opt = { ...opt, list: dropdownData[row.key] };
							return { ...row, [selectOptKeyName]: opt };
						}
						return row;
					});
				});
				setLoadingOpen(false);
			});
		} catch (error) {
			setLoadingOpen(false);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "unable to fetch values for dropdown",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};

	useEffect(() => {
		fetchSync();
		fetchDropdownValues();
	}, []);

	const handleRunQueryClick = async (e) => {
		e.preventDefault();
		setLoading(true);

		let pendingFields = [];
		filterColArry?.forEach((attr) => {
			if (isColumnDefault(attr, filterData?.[attr?.key]) && attr?.constraints?.[constraintsOptions.NOTNULL.key] === true)
				pendingFields.push(attr);
		});

		if (pendingFields?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Enter values for ${pendingFields.map((row) => row?.name)}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoading(false);
			return;
		}

		setLoadingOpen(true);
		await pythonVmInstance({
			url: `/wh-soh/download`,
			headers: {
				"Content-Type": "application/json",
			},
			method: "POST",
			data: {
				...filterData,
			},
			responseType: "blob",
		})
			.then((res) => {
				const url = URL.createObjectURL(res.data);
				FileSaver.saveAs(url, `inventory_snapshot_${new Date().toISOString().split("T")[0]}.csv`);
				setLoadingOpen(false);
				setLoading(false);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Downloaded the file",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			})
			.catch((err) => {
				console.log(err);
				setSnackBarOpen(true);
				setLoadingOpen(false);
				setLoading(false);
				setSnackBar({
					...snackBar,
					message: "Unable to Download the file",
					severity: "error",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			});
	};

	return (
		<Stack spacing={2} component="form" onSubmit={handleRunQueryClick}>
			<Typography variant="subtitle1" pt={2}>
				Last synced with UC: {sync}
			</Typography>
			<Box display="flex" columnGap={2} flexWrap={"wrap"} justifyContent={""} rowGap={2}>
				{filterColumns?.map((col) => {
					return (
						<RenderInputField
							key={col.key}
							column={col}
							data={filterData}
							setData={setFilterData}
							selectOptObjName={"select_options"}
							width={"20%"}
							longWidth={"300px"}
							disabled={false}
							disableLabel={true}
						/>
					);
				})}

				<Box alignSelf="flex-end" pb={1}>
					<Button
						variant="contained"
						disabled={loading}
						sx={{ width: "200px" }}
						type="submit"
						startIcon={loading ? <CircularProgress color="inherit" size="20px" /> : <DownloadRounded />}>
						{loading ? "Loading..." : "Download"}
					</Button>
				</Box>
			</Box>
		</Stack>
	);
};

export default InventorySnapshot;
